<template>
  <div
    class="w-full p-8 md:p-10 bg-gray-50 border-b-2 border-gray-100"
  >
    <div class="step md:text-lg">
      <ul class="flex justify-center">
        <li @click="stepClick(0)" :class="stepClazz(0)">
          Model/Design
        </li>
        <li @click="stepClick(1)" :class="stepClazz(1)">
          Preview
        </li>
        <li @click="stepClick(2)" :class="stepClazz(2)">
          Download the Code
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-stepper',
  props: ['current', 'scaffold', 'project'],
  methods: {
    async stepClick(step) {
      const current = this.current || 0;

      if (step >= current) {
        return;
      }

      if (step === 0) {
        this.$router.push({
          name: 'builder',
          params: { scaffoldId: this.scaffold.id },
        });

        return;
      }

      if (step === 1) {
        this.$router.push({
          name: 'project-preview',
          params: { projectId: this.project.id },
        });

        return;
      }
    },

    stepClazz(step) {
      const current = this.current || 0;

      if (current === step) {
        return 'current';
      }

      if (current >= step) {
        return 'done';
      }

      return '';
    },
  },
};
</script>

<style>
.step {
  width: 100%;
  color: #ccc;
}

.step ul {
  list-style: none;
  padding: 0;
  text-align: center;
  counter-reset: step;
  display: flex;
}

.step ul li {
  box-sizing: border-box;
  width: 25%;
  text-align: center;
  position: relative;
  padding-top: 40px;
}

.step ul li.current {
  color: #357edd;
}

.step ul li:before {
  text-align: center;
  content: counter(step);
  counter-increment: step;
  display: block;
  width: 30px;
  height: 30px;
  border: 3px solid #f9fbfd;
  border-radius: 50%;
  line-height: 25px;
  font-size: 18px;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  background-color: #ccc;
  color: #fff;
  z-index: 1;
}

.step ul li.done {
  cursor: pointer;
}

.step ul li.done:before {
  background-color: #20b0ee;
}

.step ul li.current:before {
  background-color: #20b0ee;
}

.step ul li:after {
  content: '';
  display: block;
  width: 100%;
  height: 3px;
  background-color: #ccc;
  top: 15px;
  position: absolute;
  margin-left: -50%;
}

.step ul li:first-child:after {
  content: none;
}

.step ul li.done + li:after {
  background-color: #20b0ee;
}
</style>
